import * as React from 'react'
import { paths } from '../../../paths'
import { NavigationButton } from '../../elementals/NavigationButton'
import { Page } from '../../elementals/Page'
import { Spacer } from '../../elementals/Spacer'
import { CheerButton } from '../../features/CheerButton'

const subPaths = ['/curriculumVitae', '/votePrompts', '/games', '/bh', '/torii']

export const Home = () => (
  <>
    <Spacer space={8} style={{ flexWrap: 'wrap' }}>
      {paths
        .filter(([path]) => subPaths.includes(path))
        .map(([path, label]) => (
          <NavigationButton path={path} key={path} style={{ marginBottom: '0.5em' }}>
            {label}
          </NavigationButton>
        ))}
    </Spacer>
    <Page>
      <h1>Hallo!</h1>
      <Spacer
        orientation="vertical"
        alignment="center"
        style={{ width: '100%', alignItems: 'center' }}
      >
        <CheerButton topic="home" />
      </Spacer>
    </Page>
  </>
)
